import { Logo } from "./Logo"

export const LogoComplete = () => {
    return <div className="flex flex-row p-4 gap-4 items-center">
        <Logo />
        <div className="flex flex-col items-start">
            <p className="font-poppins text-white text-[15.4px]">BANCO DE QUESTÕES</p>
            <p className="font-poppins text-[#5bb960] text-[13.2px] tracking-[0.3em]">PREMIUM</p>
        </div>
    </div>
}